export default "<div class=\"img\"></div>\n<div class=\"text\">{{label}}</div>"